import { Box, CircularProgress, Typography } from '@mui/material';

type LoadingIndicatorProps = {
    text?: string;
};

export function LoadingIndicator({ text }: LoadingIndicatorProps = {}) {
    return (
        <Box
            data-testid="LoadingIndicator"
            sx={{
                alignItems: 'center',
                display: 'flex',
                height: '100vh',
                justifyContent: 'center',
                width: '100%',
            }}
        >
            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <CircularProgress size={80} />
                <Typography align="center">{text || 'Loading...'}</Typography>
            </Box>
        </Box>
    );
}
